var _path, _rect, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLever(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 220,
    viewBox: "0 0 150 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6074 85.8992C38.6592 85.3886 39.0891 85 39.6023 85H105.349C105.86 85 106.288 85.3842 106.343 85.8915L120.419 214.892C120.483 215.483 120.02 216 119.425 216H26.5322C25.9401 216 25.4776 215.488 25.5373 214.899L38.6074 85.8992Z",
    stroke: "#969595",
    strokeWidth: 8
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 81,
    width: 33,
    height: 133,
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7212 38.6414C59.35 33.1548 63.7004 28.5 69.1996 28.5H80.9598C86.4027 28.5 90.7328 33.064 90.4467 38.4993L84.4508 152.422C84.2124 156.95 80.471 160.5 75.9362 160.5C71.4507 160.5 67.7321 157.025 67.4293 152.549L59.7212 38.6414Z",
    fill: "url(#paint0_linear_1926_4324)",
    stroke: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6511 7.92133C22.5214 5.56487 24.7675 4 27.2795 4H121.34C123.798 4 126.007 5.49886 126.916 7.78259L140.836 42.7826C142.403 46.7222 139.501 51 135.261 51H14.3534C10.1768 51 7.27801 46.8392 8.72495 42.9213L21.6511 7.92133Z",
    fill: "#4A4A4A",
    stroke: "#4A4A4A",
    strokeWidth: 8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1926_4324",
    x1: 75,
    y1: 28,
    x2: 75,
    y2: 161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505452,
    stopColor: "#4A4A4A",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4A4A4A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLever);
export default __webpack_public_path__ + "static/media/lever.b6d086d1b924b6b2eeb86eac98f372a5.svg";
export { ForwardRef as ReactComponent };